export {
  useQueryAdapter,
  mapFieldsArray,
  mapFields,
  type FieldMapping,
} from "./useQueryAdapter"
